import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Section } from '@/components/ui/Section'


export function RsvpSection() {
  const { t } = useTranslation()

  return (
    <Section id="rsvp" tone="none" className="text-center py-16 md:py-24 bg-[#eee8dc]">
      <div className="max-w-2xl mx-auto">
        <Link to="/rsvp" className="font-display text-[28px] md:text-[36px] text-[#93652B] tracking-[0.2em] hover:text-[#A89461] transition-colors uppercase leading-none block mb-4">
          {t('rsvp.link_text')}
        </Link>
        <p className="text-secondary-light text-base md:text-lg leading-relaxed">
          {t('rsvp.deadline')}
        </p>
      </div>
    </Section>
  )
}
